import { StationsInfo } from "types/stations"

export const stationsMockDatas: StationsInfo[] = [
    {
        id: "1",
        name: "AIX",
        address: "550 RUE PIERRE BERTHIER",
        city: "LES MILLES",
        postal_code: "13290",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "PLANNED",
        opening_times: {
            twentyfourseven: true,
            regular_hours: [],
            isOpen: true,
        },
        coordinates: {
            latitude: 43.28381,
            longitude: 5.22291,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 6,
        total_evses: 11,
        available_places: {
            total: 0,
            per_zone: [],
        },
        evses_details: [
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "null",
            type: "null",
            flat_price: "0.0",
            parking_price_per_min: null,
        },
    },
    {
        id: "2",
        name: "AMIENS",
        address: "107 AVENUE ROGER DUMOULIN",
        city: "AMIENS",
        postal_code: "80080",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "OPEN",
        opening_times: {
            twentyfourseven: false,
            regular_hours: [
                {
                    period_day: "lundi-vendredi",
                    period_hour: "08:30-22:30",
                },
                {
                    period_day: "samedi-dimanche",
                    period_hour: "Fermé",
                },
            ],
            isOpen: true,
        },
        coordinates: {
            latitude: 49.942222,
            longitude: 2.279236,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 10,
        total_evses: 19,
        available_places: {
            total: 14,
            per_zone: [
                {
                    zone: "LV",
                    total: 12,
                },
                {
                    zone: "HDV",
                    total: 2,
                },
            ],
        },
        evses_details: [
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 15,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 16,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 17,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 16,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 15,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 22,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 22,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 17,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 11,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "6.0",
            type: "TIME",
            flat_price: "5.0",
            parking_price_per_min: null,
        },
    },
    {
        id: "3",
        name: "AVOINE",
        address: "1 RUE DENIS PAPIN",
        postal_code: "37420",
        city: "AVOINE",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "OPEN",
        opening_times: {
            twentyfourseven: false,
            regular_hours: [
                {
                    period_day: "lundi-vendredi",
                    period_hour: "08:30-22:30",
                },
                {
                    period_day: "samedi-dimanche",
                    period_hour: "Fermé",
                },
            ],
            isOpen: true,
        },
        coordinates: {
            latitude: 47.217163,
            longitude: 0.1641,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 7,
        total_evses: 13,
        available_places: {
            total: 9,
            per_zone: [
                {
                    zone: "LV",
                    total: 8,
                },
                {
                    zone: "HDV",
                    total: 1,
                },
            ],
        },
        evses_details: [
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "6.0",
            type: "TIME",
            flat_price: "5.0",
            parking_price_per_min: null,
        },
    },
    {
        id: "4",
        name: "BONNEVILLE",
        address: "RUE DES SARCELLES - ZAC BORDETS II",
        city: "BONNEVILLE",
        postal_code: "74130",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "CONSTRUCTION",
        opening_times: {
            twentyfourseven: true,
            regular_hours: [],
            isOpen: true,
        },
        coordinates: {
            latitude: 46.073251,
            longitude: 6.432285,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 6,
        total_evses: 11,
        available_places: {
            total: 0,
            per_zone: [],
        },
        evses_details: [
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "0.59",
            type: "ENERGY",
            flat_price: null,
            parking_price_per_min: "1.0",
        },
    },
    {
        id: "5",
        name: "DURTAL",
        address: "9 RUE JOSEPH CUGNOT",
        postal_code: "49430",
        city: "DURTAL",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "OPEN",
        opening_times: {
            twentyfourseven: true,
            regular_hours: [],
            isOpen: true,
        },
        coordinates: {
            latitude: 47.670575,
            longitude: -0.255112,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 6,
        total_evses: 11,
        available_places: {
            total: 7,
            per_zone: [
                {
                    zone: "LV",
                    total: 6,
                },
                {
                    zone: "HDV",
                    total: 1,
                },
            ],
        },
        evses_details: [
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "0.59",
            type: "ENERGY",
            flat_price: null,
            parking_price_per_min: "1.0",
        },
    },
    {
        id: "6",
        name: "FOS-SUR-MER",
        address: "105 ROUTE DU GUIGNONNET",
        postal_code: "13270",
        city: "FOS-SUR-MER",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "CONSTRUCTION",
        opening_times: {
            twentyfourseven: true,
            regular_hours: [],
            isOpen: true,
        },
        coordinates: {
            latitude: 43.451774,
            longitude: 4.930804,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 6,
        total_evses: 11,
        available_places: {
            total: 0,
            per_zone: [],
        },
        evses_details: [
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "0.59",
            type: "ENERGY",
            flat_price: null,
            parking_price_per_min: "1.0",
        },
    },
    {
        id: "7",
        name: "ORVAULT",
        address: "2 RUE DE LA GARENNE",
        postal_code: "44700",
        city: "ORVAULT",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "OPEN",
        opening_times: {
            twentyfourseven: false,
            regular_hours: [
                {
                    period_day: "lundi-vendredi",
                    period_hour: "08:30-22:30",
                },
                {
                    period_day: "samedi-dimanche",
                    period_hour: "Fermé",
                },
            ],
            isOpen: true,
        },
        coordinates: {
            latitude: 47.258574,
            longitude: -1.645051,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 7,
        total_evses: 13,
        available_places: {
            total: 9,
            per_zone: [
                {
                    zone: "LV",
                    total: 8,
                },
                {
                    zone: "HDV",
                    total: 1,
                },
            ],
        },
        evses_details: [
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "0.59",
            type: "ENERGY",
            flat_price: "5.0",
            parking_price_per_min: "1.0",
        },
    },
    {
        id: "8",
        name: "PARDIES",
        address: "14 CHEMIN DEPARTEMENTAL",
        postal_code: "64150",
        city: "PARDIES",
        country: "FR",
        status: "OPEN",
        opening_times: {
            twentyfourseven: true,
            regular_hours: [],
            isOpen: true,
        },
        coordinates: {
            latitude: 43.369089,
            longitude: -0.584964,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 7,
        total_evses: 13,
        available_places: {
            total: 9,
            per_zone: [
                {
                    zone: "LV",
                    total: 8,
                },
                {
                    zone: "HDV",
                    total: 1,
                },
            ],
        },
        evses_details: [
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "0.59",
            type: "ENERGY",
            flat_price: "5.0",
            parking_price_per_min: "1.0",
        },
    },
    {
        id: "9",
        name: "PIERRELATTE",
        address: "2 RUE JACQUES MONOD",
        postal_code: "26700",
        city: "PIERRELATTE",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "OPEN",
        opening_times: {
            twentyfourseven: true,
            regular_hours: [],
            isOpen: true,
        },
        coordinates: {
            latitude: 44.36711,
            longitude: 4.710757,
        },
        facilities: ["WIFI", "WC", "SNACKING"],
        total_charging_points: 7,
        total_evses: 13,
        available_places: {
            total: 9,
            per_zone: [
                {
                    zone: "LV",
                    total: 8,
                },
                {
                    zone: "HDV",
                    total: 1,
                },
            ],
        },
        evses_details: [
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "0.59",
            type: "ENERGY",
            flat_price: "5.0",
            parking_price_per_min: "1.0",
        },
    },
    {
        id: "10",
        name: "VENISSIEUX",
        address: "38 RUE EUGENE HENAFF",
        postal_code: "69200",
        city: "VENISSIEUX",
        country: "FR",
        custom_data: { is_private: false, status: "OPEN" },
        status: "OPEN",
        opening_times: {
            twentyfourseven: false,
            regular_hours: [
                {
                    period_day: "lundi-vendredi",
                    period_hour: "08:30-22:30",
                },
                {
                    period_day: "samedi-dimanche",
                    period_hour: "Fermé",
                },
            ],
            isOpen: true,
        },
        coordinates: {
            latitude: 45.690972,
            longitude: 4.906909,
        },
        facilities: ["WC", "SNACKING"],
        total_charging_points: 7,
        total_evses: 13,
        available_places: {
            total: 9,
            per_zone: [
                {
                    zone: "LV",
                    total: 8,
                },
                {
                    zone: "HDV",
                    total: 1,
                },
            ],
        },
        evses_details: [
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2",
                charging_power: 3,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "LV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 14,
            },
            {
                zone: "HDV",
                status: "available",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
            {
                zone: "HDV",
                status: "unavailable",
                connector_type: "IEC_62196_T2_COMBO",
                charging_power: 360,
                physical_reference: 1,
            },
        ],
        tariff: {
            currency: "EUR",
            price: "0.59",
            type: "ENERGY",
            flat_price: null,
            parking_price_per_min: null,
        },
    },
]
